import React from 'react'
import {GridTable, ResultsPager} from '../../../../Components/Grid'
import {AphResultsRow} from "./AphResultsRow";
import type {SearchCriteria} from "../../../../types";


interface AphSearchResultsViewProps {
    aphResources: Record<string, any>[];
    aphSearchCriteria: SearchCriteria;
    canManageAphCatalogItems: boolean;
    handleAddToQueue: (id: string) => void;
    handleEdit: (id: string) => void;
    handleSetAphSearchCriteria: (criteria: SearchCriteria) => void;
    onAvailabilityStatusClick: (catalogId: string, value: string) => void;
    totalRecords: number;
    redirect?: (path: string) => void;
    updatedAvailabilityDropdowns?: string[];
}

export const AphSearchResultsView = ({
                                        aphResources,
                                        aphSearchCriteria,
                                        canManageAphCatalogItems,
                                        handleAddToQueue,
                                        handleEdit,
                                        handleSetAphSearchCriteria,
                                        onAvailabilityStatusClick,
                                        totalRecords,
                                        updatedAvailabilityDropdowns

                                    }: AphSearchResultsViewProps) => {

    const handleOrderClick = (event: React.MouseEvent<HTMLElement>) => {
        let criteria = {...aphSearchCriteria, loadSearchResults: true};
        criteria.UpdateSorting((event.target as HTMLElement).dataset.id || '');
        handleSetAphSearchCriteria(criteria);
    };
    const handleFirstClick = () => {
        let criteria = {...aphSearchCriteria, loadSearchResults: true};
        criteria.First();
        handleSetAphSearchCriteria(criteria);
    };
    const handlePreviousClick = () => {
        let criteria = {...aphSearchCriteria, loadSearchResults: true};
        criteria.Previous();
        handleSetAphSearchCriteria(criteria);
    };
    const handleNextClick = () => {
        let criteria = {...aphSearchCriteria, loadSearchResults: true};
        criteria.Next();
        handleSetAphSearchCriteria(criteria);
    };
    const handleLastClick = () => {
        let criteria = {...aphSearchCriteria, loadSearchResults: true};
        criteria.Last(totalRecords);
        handleSetAphSearchCriteria(criteria);
    };


    const pager = (isSecondaryPager: boolean) => <ResultsPager
        handleFirstClick={handleFirstClick}
        handlePreviousClick={handlePreviousClick}
        handleNextClick={handleNextClick}
        handleLastClick={handleLastClick}
        isSecondaryPager={isSecondaryPager}
        totalRecords={totalRecords}
        recordsPerPage={aphSearchCriteria.recordsPerPage}
        currentPage={aphSearchCriteria.page}
        disabled={false}
    />;

return <>
    {pager(false)}
    <GridTable className={"searchResults"} >
        <thead>
        <tr>
            <th
                  onClick={handleOrderClick} className="is-clickable" data-id="catalogNumber">Catalog Number
            </th>
            <th
                  onClick={handleOrderClick} className="is-clickable" data-id="title">Title
            </th>
            <th
                   onClick={handleOrderClick}  className="is-clickable" data-id="cost">Cost
            </th>
            {
                canManageAphCatalogItems &&
                <th
                    onClick={handleOrderClick} className="is-clickable" data-id="availabilityStatus">Availability Status
                </th>
            }

                   <th
                  data-id="actions">Actions
            </th>
        </tr>
        </thead>
        <tbody>
            {aphResources.map((aphResource: Record<string, any>) => {
                return (<AphResultsRow
                    key={aphResource.id}
                    aphResource={aphResource}
                     canManageAphCatalogItems={canManageAphCatalogItems}
                    handleAddToQueue={handleAddToQueue}
                    handleEdit={handleEdit}
                    onAvailabilityStatusClick={onAvailabilityStatusClick}
                    updatedAvailabilityDropdowns={updatedAvailabilityDropdowns}



                />);
            })}
            </tbody>

        </GridTable>
        {pager(true)}

    </>;
}

